import { To, useHref } from 'react-router';
import { TenantName } from '@packlink/packlink-sdk';
import { useHelpCenter, HELP_CENTER_KEYS } from '@packlink/provider';
import { TenantUtils } from '@utils/tenant';

// Currently EBAYGB users doesn't have access to Shipments Reference number
// hence we are redirecting them to Help Center instead of Support Center.

/**
 * This hook is only needed if the link to the support center is outside /private/support-center to control where EBAYGB users are redirected.
 */
export function useSupportCenterUrl(to: To) {
    const getHelpCenterPage = useHelpCenter();
    const supportUrl = useHref(to);

    const helpCenterUrl = getHelpCenterPage(HELP_CENTER_KEYS.home);

    // TODO: Remove this check of the tenant name
    // https://auctane.atlassian.net/browse/PCK-3097
    const isEBAYGB = TenantUtils.getTenantName() === TenantName.EBAYGB;

    return isEBAYGB ? helpCenterUrl : supportUrl;
}
